import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="max-w-3xl mx-auto px-6 pt-12 pb-8" data-id="element-75">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="space-y-6" data-id="element-76">
        <div className="space-y-4 text-center sm:text-left" data-id="element-77">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-brand-brown leading-tight" data-id="element-78">
            Mein Hund hatte ständig Sodbrennen – bis ich das hier entdeckt habe
          </h1>
          <p className="text-lg sm:text-xl text-stone-600 font-serif leading-relaxed" data-id="element-79">
            Eine Geschichte über nächtliches Würgen, hilflose Tierarztbesuche
            und die Lösung, die alles verändert hat.
          </p>
          <div className="flex items-center justify-center sm:justify-start gap-3 pt-2" data-id="element-80">
            <div className="w-10 h-10 rounded-full bg-stone-200 overflow-hidden" data-id="element-81">
              <img src="https://images.unsplash.com/photo-1633722715463-d30f4f325e24?auto=format&fit=crop&w=100&q=80" alt="Max der Hund" className="w-full h-full object-cover" data-id="element-82" />
            </div>
            <div className="text-sm font-sans text-stone-500" data-id="element-83">
              <span className="font-medium text-stone-700" data-id="element-84">Von Lisa & Max</span>
              <span className="mx-2" data-id="element-85">·</span>
              <span data-id="element-86">12. März 2025</span>
            </div>
          </div>
        </div>

        <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3] sm:aspect-[16/9] mt-8" data-id="element-87">
          <img src="https://images.unsplash.com/photo-1518717758536-85ae29035b6d?auto=format&fit=crop&w=1200&q=80" alt="Max schaut traurig" className="w-full h-full object-cover" data-id="element-88" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" data-id="element-89"></div>
          <span className="absolute bottom-3 right-4 text-xs text-white/80 font-medium tracking-wide bg-black/30 px-2 py-1 rounded-full backdrop-blur-sm" data-id="element-90">
            Golden Retriever
          </span>
        </div>
      </motion.div>
    </section>;
}